type ClientEnv = {
  VITE_CLIENT: string;
  VITE_PYTHON_BACKEND_URL: string;
  VITE_LOCAL?: string;
  VITE_REALPERSON_ENV?: string;
};

const env = (import.meta as unknown as { env: ClientEnv }).env;

export const CLIENT_ENV = env.VITE_CLIENT;
export const PYTHON_BACKEND = env.VITE_PYTHON_BACKEND_URL;
export const IS_LOCAL = env.VITE_LOCAL;
export const REALPERSON_ENV = env.VITE_REALPERSON_ENV;
